import { Typography } from '@material-ui/core';

import * as React from 'react';

interface Props {
  children: React.ReactNode;
  classes: Record<string, string>;
}

export const MessageCell: React.FC<Props> = (props) => {
  const { classes, children } = props;
  return (
    <Typography variant="caption" className={classes.lastRefresh}>
      {children}
    </Typography>
  );
};
MessageCell.displayName = 'LastRefresh.MessageCell';
